import { Logo } from "./Logo";
import { NAV_LINKS, CONTACT } from "@/data/content";
import { scrollToId } from "@/lib/scroll";

export const Footer = () => (
  <footer className="bg-ink text-linen grain" data-testid="footer">
    <div className="container-x py-16 lg:py-20 grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr]">
      <div>
        <Logo light />
        <p className="mt-6 max-w-sm text-sm text-linen/55 leading-relaxed">Premium custom curtains, blinds and plantation shutters — measured, made and installed across Melbourne.</p>
        <p className="mt-6 text-xs text-linen/40 font-mono">{CONTACT.address}<br />{CONTACT.abn}</p>
      </div>
      <div>
        <p className="eyebrow mb-5">Explore</p>
        <ul className="space-y-3">
          {NAV_LINKS.map((l) => <li key={l.id}><button onClick={() => scrollToId(l.id)} className="text-sm text-linen/70 hover:text-brass transition-colors" data-testid={`footer-link-${l.id}`}>{l.label}</button></li>)}
        </ul>
      </div>
      <div>
        <p className="eyebrow mb-5">Contact</p>
        <ul className="space-y-3 text-sm text-linen/70">
          <li><a href={`tel:${CONTACT.phone.replace(/\s/g, "")}`} className="hover:text-brass transition-colors">{CONTACT.phone}</a></li>
          <li><a href={`mailto:${CONTACT.email}`} className="hover:text-brass transition-colors">{CONTACT.email}</a></li>
          <li className="text-linen/40 text-xs pt-2">Mon – Fri 8am – 7pm · Sat 9am – 1pm</li>
        </ul>
      </div>
    </div>
    <div className="border-t border-line-dark">
      <div className="container-x py-8 flex flex-col lg:flex-row gap-4 lg:items-center lg:justify-between text-[11px] text-linen/40 leading-relaxed">
        <p data-testid="footer-copyright">Copyright © 2026 HAPPY 23 BLINDS & SHUTTER. All Rights Reserved.</p>
        <p className="max-w-2xl" data-testid="footer-compliance">All corded internal window coverings are supplied and installed in accordance with the ACCC Competition and Consumer (Corded Internal Window Coverings) Safety Standard 2014. Workmanship and installation covered by our 10-year warranty; fabrics and motors carry manufacturer warranties.</p>
      </div>
    </div>
  </footer>
);
